
export default {
  props: {
    recipe: {
      type: Object,
      required: true,
    },
  },
  computed: {
    totalPreparationTime() {
      const waitingTimeSplit = this.recipe.wachttijd ? this.recipe.wachttijd.split(':') : [0, 0];
      const preperationTimeSplit = this.recipe.bereidingstijd ? this.recipe.bereidingstijd.split(':') : [0, 0];

      const waitingTimeInMinutes = (+waitingTimeSplit[0]) * 60 + (+waitingTimeSplit[1]);
      const preperationTimeInMinutes = (+preperationTimeSplit[0]) * 60 + (+preperationTimeSplit[1]);
      const total = waitingTimeInMinutes + preperationTimeInMinutes;

      const minutes = total % 60;
      const hours = ('0' + ((total - minutes) / 60)).slice(-2);

      return `${hours}:${('0' + minutes).slice(-2)}`;
    },
  },
};
